interface SlackMessageFallback {
	slackId: string
	createdAt: number
}

interface SlackLinkArgs {
	teamUrl: string | null | undefined
	slackChannelId: string | null | undefined
	slackReplyId: string | null | undefined
	// Top-level (gap) threads have no slackReplyId until a Slack reply claims them.
	// Fall back to the first captured Slack message so the link always resolves.
	slackMessages?: ReadonlyArray<SlackMessageFallback>
}

// cid makes Slack jump to and highlight the message; thread_ts opens it inside the thread pane.
function permalink(
	teamUrl: string,
	channelId: string,
	ts: string,
	threadTs: string,
): string {
	const base = `${teamUrl}archives/${channelId}/p${ts.replace(".", "")}`
	const params = new URLSearchParams({ cid: channelId, thread_ts: threadTs })
	return `${base}?${params.toString()}`
}

interface SlackChannelRowArgs {
	channel: { name: string; channelId: string; slackConnectSettingsId: string }
	connections: ReadonlyArray<{ id: string; teamUrl: string }>
}

/** The thread's channel, linked through its own Slack workspace rather than the first connected one. */
export function getSlackChannelRow({
	channel,
	connections,
}: SlackChannelRowArgs): { label: string; url: string } {
	const teamUrl = connections.find(
		(row) => row.id === channel.slackConnectSettingsId,
	)?.teamUrl
	return {
		label: `#${channel.name}`,
		url: teamUrl ? `${teamUrl}archives/${channel.channelId}` : "",
	}
}

export function getSlackMessageLink({
	teamUrl,
	slackChannelId,
	slackReplyId,
	slackMessages,
}: SlackLinkArgs): string {
	if (!teamUrl || !slackChannelId) return ""

	if (slackReplyId) {
		return permalink(teamUrl, slackChannelId, slackReplyId, slackReplyId)
	}

	const firstMessage = slackMessages
		?.filter((m) => m.slackId)
		.sort((a, b) => a.createdAt - b.createdAt)[0]
	if (!firstMessage) return ""

	return permalink(
		teamUrl,
		slackChannelId,
		firstMessage.slackId,
		firstMessage.slackId,
	)
}
